import mitt from 'mitt';

export default defineNuxtPlugin(() => {
  const emitter = mitt();

  return {
    provide: {
      event: emitter.emit, // Will emit an event
      listen: emitter.on, // Will register a listener for an event
      // Removes a listener registered with $listen. mitt keeps a subscription
      // until it is explicitly removed, and without this there was no way to
      // remove one at all — so every component that subscribed leaked it for
      // the lifetime of the page. Pass the same handler reference $listen got.
      unlisten: emitter.off,
    },
  };
});
